export default class CanalWhatsAppTemplateModel {
  constructor({
    id = 0,
    canalWhatsAppId = 0,
    nome = '',
    tipoId = 1,
    zenviaTemplateId = null,
    conteudo = '',
    ativo = true,
  } = {}) {
    this.id = id
    this.canalWhatsAppId = canalWhatsAppId
    this.nome = nome
    this.tipoId = tipoId
    this.zenviaTemplateId = zenviaTemplateId
    this.conteudo = conteudo
    this.ativo = ativo
  }
}
